import React from "react";

import "../scss/ui/Logo.scss";
export default function Logo() {
  return <div className="logo"></div>;
}
